import {DEFAULT_NS} from "@i18n/constants";
import getLocale from "@i18n/getLocale";
import {GetServerSideProps} from "next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {I18nNamespace} from "@i18n/constants";

export const defaultNamespaces = [DEFAULT_NS];

export default function withLocaleServerSideProps<
  T extends {[key: string]: unknown} = {[key: string]: unknown},
>(
  gssp: GetServerSideProps<T>,
  namespaces: I18nNamespace[] = defaultNamespaces,
): GetServerSideProps {
  return async context => {
    const locale = getLocale(context.req);
    const origResult = await gssp(context);
    if ("redirect" in origResult || "notFound" in origResult) {
      return origResult;
    }
    return {
      ...origResult,
      props: {
        ...(origResult.props ?? {}),
        ...(await serverSideTranslations(locale, namespaces)),
      },
    };
  };
}
